import { Mail, MessageCircle, Table2, Info } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  TIERS_CORREO,
  TIERS_WHATSAPP,
  TIERS_CORREO_WHATSAPP,
  formatearNumero,
  formatearPrecio,
} from '../lib/pricing-tiers'

interface PricingTableModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PricingTableModal({ open, onOpenChange }: PricingTableModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-gray-900 flex items-center">
            <Table2 className="w-6 h-6 text-teal-500 mr-2" />
            Tabla de Precios Multichannel
          </DialogTitle>
        </DialogHeader>

        <div className="overflow-auto">
          <table
            className="w-full mt-4"
            style={{
              borderCollapse: 'separate',
              borderSpacing: 0,
              borderRadius: '15px',
              overflow: 'hidden',
              border: '1px solid #ffffff',
            }}
          >
            <thead>
              <tr>
                <th
                  className="text-lg font-semibold text-white text-center p-4"
                  style={{
                    background: '#0d9488',
                    borderRight: '1px solid #115e59',
                    borderBottom: '1px solid #115e59',
                    borderTopLeftRadius: '15px',
                  }}
                >
                  Cantidad
                </th>
                <th
                  className="text-lg font-semibold text-white text-center p-4"
                  style={{
                    background: '#0d9488',
                    borderRight: '1px solid #115e59',
                    borderBottom: '1px solid #115e59',
                  }}
                >
                  <Mail className="w-4 h-4 inline-block mr-2" />
                  Correo
                </th>
                <th
                  className="text-lg font-semibold text-white text-center p-4"
                  style={{
                    background: '#0d9488',
                    borderRight: '1px solid #115e59',
                    borderBottom: '1px solid #115e59',
                  }}
                >
                  <MessageCircle className="w-4 h-4 inline-block mr-2" />
                  WhatsApp
                </th>
                <th
                  className="text-lg font-semibold text-white text-center p-4"
                  style={{
                    background: '#0d9488',
                    borderBottom: '1px solid #115e59',
                    borderTopRightRadius: '15px',
                  }}
                >
                  <Mail className="w-4 h-4 inline-block mr-1" />
                  <MessageCircle className="w-4 h-4 inline-block mr-1" />
                  Correo + WhatsApp
                </th>
              </tr>
            </thead>
            <tbody>
              {TIERS_CORREO.map((tier, i) => {
                const isLast = i === TIERS_CORREO.length - 1
                return (
                  <tr
                    key={tier.volumen}
                    className={`${i % 2 === 1 ? 'bg-gray-50' : 'bg-white'} hover:bg-teal-50`}
                  >
                    <td
                      className="py-3 px-4 text-center font-bold text-gray-900"
                      style={{
                        borderRight: '1px solid #e5e7eb',
                        borderBottom: isLast ? 'none' : '1px solid #e5e7eb',
                        ...(isLast ? { borderBottomLeftRadius: '15px' } : {}),
                      }}
                    >
                      {formatearNumero(tier.volumen)}
                    </td>
                    <td
                      className="py-3 px-4 text-center"
                      style={{
                        borderRight: '1px solid #e5e7eb',
                        borderBottom: isLast ? 'none' : '1px solid #e5e7eb',
                      }}
                    >
                      {formatearPrecio(TIERS_CORREO[i].precio)}
                    </td>
                    <td
                      className="py-3 px-4 text-center"
                      style={{
                        borderRight: '1px solid #e5e7eb',
                        borderBottom: isLast ? 'none' : '1px solid #e5e7eb',
                      }}
                    >
                      {formatearPrecio(TIERS_WHATSAPP[i].precio)}
                    </td>
                    <td
                      className="py-3 px-4 text-center"
                      style={{
                        borderBottom: isLast ? 'none' : '1px solid #e5e7eb',
                        ...(isLast ? { borderBottomRightRadius: '15px' } : {}),
                      }}
                    >
                      {formatearPrecio(TIERS_CORREO_WHATSAPP[i].precio)}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        {/* Info Note */}
        <div className="mt-6 p-4 bg-teal-50 rounded-lg border border-teal-500">
          <div className="flex items-start">
            <Info className="w-5 h-5 text-teal-500 mr-2 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm text-gray-700 font-semibold mb-1">Información importante:</p>
              <ul className="text-xs text-gray-600 space-y-1 list-disc list-inside">
                <li>Los precios mostrados son el costo por unidad (email o mensaje)</li>
                <li>Volúmenes intermedios se calculan con el precio unitario del tier inmediato inferior</li>
                <li>Sin costos ocultos ni comisiones adicionales</li>
              </ul>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
